module.exports = __webpack_public_path__ + "img/user_folder.0840bdc8.svg";